import styled from '@xstyled/styled-components'
import { Image } from '../image/image'
import type { AvatarSize, Pixels, StyledAvatarProps } from './Common.styles'
import { StyledCommonAvatar } from './Common.styles'

export const StyledAvatar = styled(StyledCommonAvatar)({
  backgroundColor: 'sky.l1',
  color: 'white'
})

export const StyledAvatarImage = styled(Image)({
  height: '100%',
  width: '100%',
  borderRadius: '50%',
  outline: 'transparent solid 2px !important',
  outlineOffset: '2px'
})

export function avatarSizeToInitialsSize(
  avatarSize: AvatarSize = 'md'
): Pixels {
  const sizeMap: Record<AvatarSize, Pixels> = {
    '2xl': '52px',
    xl: '38px',
    lg: '26px',
    md: '20px',
    sm: '12px',
    xs: '8px',
    '2xs': '6px'
  }
  return sizeMap[avatarSize]
}

export const StyledInitials = styled.spanBox<StyledAvatarProps>(props => ({
  fontSize: avatarSizeToInitialsSize(props.size)
}))
